/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-09 17:00:59
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-22 14:48:23
 */
import request from "../../utils/request";
import server from "./config";
import { getToken } from "../../utils/auth";
export default {
    /**
     * 获取推送内容详情
     */
    educationDetail: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/sendMessage/1/getSendMessageDetailById`,
            method: "post",
            data
        });
    },
    /**
     * 获取文章详情
     */
    getArticleDetailById: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/sendMessage/1/getArticleDetailById`,
            method: "post",
            data
        });
    }
    /**
     * 获取医阵营文章详情
     */
    // getYzyArticleDetailById: (id, params) => {
    //     return request({
    //         url: `${process.env.YZY_API_URL}/web/works/${id}`,
    //         method: "get",
    //         params,
    //         headers: {
    //             userType: 1,
    //             token: getToken()
    //         }
    //     });
    // }
};



// WEBPACK FOOTER //
// ./src/api/modules/education.js